import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as JSZip from 'jszip';
import { ToastrService } from 'ngx-toastr';
import { TemplateUploadModalComponent } from '../template-upload-modal/template-upload-modal.component';
import { DeleteTemplateModal } from '../templates/delete-template-modal.component';
import { EditTemplateModalComponent } from '../../components/edit-template-modal/edit-template-modal.component';
import { TemplatesService } from '../templates/templates.service';
import { UpdateTemplateModal } from '../templates/update-template-modal.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import * as FileSaver from 'file-saver';
import { auto } from '@popperjs/core';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { TemplateCreationComponent } from '../template-creation/template-creation.component';
import { SearchTemplateModel } from 'src/app/Models/SearchTemplateModel';
import { RatingModalComponent } from '../rating-modal/rating-modal.component';
import { ViewReviewModalComponent } from '../view-review-modal/view-review-modal.component';
import { ViewfileComponent } from 'src/app/components/viewfile/viewfile.component';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { Location } from '@angular/common';
import { ExcelService } from 'src/app/services/excel-service.service';

@Component({
  selector: 'app-template-docs',
  templateUrl: './template-docs.component.html',
  styleUrls: ['./template-docs.component.css']
})
export class TemplateDocsComponent {
  public templates: any = [];
  public dataLoaded: boolean = true;
  type: string;
  public searchTemplateModel = new SearchTemplateModel()
  useremail: string;
  role: string;
  superAdminAndAdmin: boolean;
  adminSuperAdminLeadership: boolean;
  constructor(private router: Router,
    private _location: Location,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private _service: TemplatesService,
    private _proposalService: AddProposalService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private excel: ExcelService) { }
  selectedTemplateCount: number = 0;
  currentDocuments: any = [];
  selectedTemplate: any
  public serviceLinesForDropDown: any = []
  public serviceLines: any = [];
  public competency: any = [];
  selectedTemplateName: string;
  selectedDocsForDownload = []
  selectAll = false;
  canDownload = false;
  templateResponse: any = [];
  templateResponseForTable
  searchText: string = '';
  ratings: any = [];
  showTemplates: boolean = true;
  subTemplate: any = [];
  public loading: boolean = false
  selectedImage = "url('../../../assets/images/File_closed.svg')";
  defaultImage = "url('../../../assets/images/File_open.svg')";
  hoverImage = "url('../../../assets/images/File_closed_hover.svg')";
  mostDownloadedProjects: void;
  mostViewedProjects: void;
  searchResultsViewFlag = false;
  throttle = 1;
  distance = 1000;
  size = 12;
  from = 0;
  public categoryList = [
    {
      name: "Solutioning Templates",
      iconUrl: "Case_studies.svg",
      description:
        " Briefs on real-world applications of ACS’ services ",
      iconBGColor: "#EFEFFD",
      data: "Solutioning Templates",
    },
    {
      name: "Governance Templates",
      iconUrl: "corporate_decks.svg",
      description:
        "High-level overview of ACS – the company, its history.",
      iconBGColor: "#E6FAF3",
      data: "Governance Templates",
    },
    {
      name: "Proposal Templates",
      iconUrl: "industries_decks.svg",
      description:
        "ACS’ capabilities, solutionsand relevant case studies .",
      iconBGColor: "#FFEFED",
      data: "Proposal Templates",
    },
    {
      name: 'Case Study Templates',
      iconUrl: 'Service_decks.svg',
      description: 'presentations illustrating capabilities of ACS group companies. ',
      iconBGColor: '#FDF8E8',
      data: 'Case Study Templates'

    },
    {
      name: "Delivery Quality Maturity Templates",
      iconUrl: "templates.svg",
      description:
        "Downloadable pre-approved standard case study templates",
      iconBGColor: "#EFEFFD",
      data: "Delivery Quality Maturity Templates",
    },
  ];
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      {
        breakpoint: 1470,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1182,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          focusOnSelect: false,
          swipe: true,
        },
      },


      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
    ],
  };
  selectedTemplateDocCount = 0;
  artifactoryView = 'card';
  displayedColumns: string[] = [
    'fileName',
    'subCategoryTemplate',
    'templateName',
    'templateDescription',
    'templateTags',
    'contactPerson',
    'actions'
  ];

  ngOnInit() {
    this.role = this.auth.getRole();
    this.useremail = this.auth.getEmailId();
    if (this.role.includes(GsdRoles.SuperAdmin) || this.role.includes(GsdRoles.Admin)) {
      this.superAdminAndAdmin = true;
    }
    if (this.role.includes(GsdRoles.SuperAdmin) || this.role.includes(GsdRoles.Admin) || this.role.includes(GsdRoles.Leadership)) {
      this.adminSuperAdminLeadership = true;
    }
    this.defaultTemplatesLoad();
  }

  fetchRating(documents){
    for (const templateId of documents) {
      this._service.GetRatingsByTemplateId(templateId.id).subscribe((res) => {
        this.ratings = res;
        templateId.ratings = this.ratings;
      });
    }
  }
  defaultTemplatesLoad(id?) {
    this.loading = true;
    this.dataLoaded = true;
    this.templates = Object.assign([])
    this.cd.detectChanges();
    this._service.getAllTemplateCategories().subscribe(x => {
      this.templates = Object.assign([], x.data.items);
      this.dataLoaded = true;
      this.cd.detectChanges();
      if (localStorage.getItem("selectedTemplate")) {
        id = localStorage.getItem("selectedTemplate")
      }
      this.selectedTemplate = this.route.snapshot.paramMap.get("selectedtemplate");
      const selectedTemplate = this.templates.find(x => x.category == this.selectedTemplate);
      this.selectedTemplateDocCount = selectedTemplate ? selectedTemplate.docCount : 0;
      
      this.selectedTemplate = selectedTemplate.id

      this.getTemplatesById(this.selectedTemplate, this.from, this.size);
    }, error => {
    })
    this.getserviceareas();
    this.getServiceLines()
  }
  getServiceLines(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._proposalService.getServiceLines().subscribe(x => {
        this.competency = x.data;
        x.data.forEach(ser => {
          x = this.serviceLines.some(x => x.name == ser.name);
          if (!x) {
            this.serviceLines.push(ser);
          }
        });
        this.loading = false;
        resolve(this.serviceLines);
      })
    });
  }
  getserviceareas(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._proposalService.getServiceAreas().subscribe(x => {
        x.data.forEach(tech => {

          this.serviceLinesForDropDown.push(
            tech
          );
        });
      });
      resolve(this.serviceLinesForDropDown);
    })


  }
  openRatingTemplate(data) {
    this._service.GetRatingsByTemplateId(data.id).subscribe((res) => {

      this.ratings = res
      this.useremail = this.auth.getEmailId();
      data.ratings = this.ratings
        data.name = data.fileName
      const dialogRef = this.dialog.open(RatingModalComponent, {
        width: auto,
        height: auto,
        data

      });
      dialogRef.afterClosed().subscribe(result => {
        if (result)
          this.loading = true
        //todo: temporary fix; need to refresh data only
        if (result?.email) {
          this._service.UpdateRating(result).subscribe(res => {
            this.loading = false
            setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
            setTimeout(() => this.searchButton(), 1000);
            this.cd.detectChanges();
            this.toastr.success("Rating Updated Successfully")
          })

        } else {
          this._service.AddRating(result).subscribe(res => {
            this.loading = false
            setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
            setTimeout(() => this.searchButton(), 1000);
            this.cd.detectChanges();
            this.toastr.success("Rating Added Successfully")
          })
          this.loading = false
        }
      });
      this.loading = false
    })
  }
  GetRatingsByTemplateId(id) {
    this._service.GetRatingsByTemplateId(id).subscribe((res) => {
      this.ratings = res
    })
  }
  openReviews(data) {
    this._service.GetRatingsByTemplateId(data.id).subscribe((res) => {
      this.loading = false;
      this.ratings = res;
      data.ratings = this.ratings

      if (this.ratings.length >= 1) {
        const dialogRef = this.dialog.open(ViewReviewModalComponent, {
          width: '400px ',
          height: '400px',
          data

        });
        dialogRef.afterClosed().subscribe(result => {
          //todo: temporary fix; need to refresh data only
          if (result) {
            this._service.AddTemplateCategory(result).subscribe(res => {
              this.loading = false;
            })
          }
        });
      }
    })
  }

  downloadAllTemplate(selectedTemplates) {
    let templateIds = this.selectedDocsForDownload.map(i => i.id)
    this._service.downloadAllTemplate(templateIds).subscribe(data => {
      this.createZip(data.data, 'Templates');
      let resultData = data.data;
      for (let i = 0; i < resultData.length; i++) {
        this.downloadFile("", selectedTemplates[i].name);
      }
      setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
      this.templates.map(i => {
        if (i.id == this.selectedTemplate) {
          i.downloadCount = i.downloadCount + templateIds.length;
        }
      })
    });
  }

  async createZip(files: any[], zipName: string) {
    const zip = new JSZip();
    const name = zipName + '.zip';
    // tslint:disable-next-line:prefer-for-of  
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter].sharepointId;
      const fileData: any = await this._service.getFile(element);
      const b: any = new Blob([fileData], { type: fileData.type });
      zip.file(files[counter].name, b);
    }
    zip.generateAsync({ type: 'blob' }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
  }

  getSubTemplates(event) {
    this._proposalService.getSubTemplatesDropdown(this.selectedTemplate).subscribe((res) => {
      this.subTemplate = res.data;
    })
  }

  selectForDownload(event, data) {
    if (event.target.checked) {
      this.selectedDocsForDownload.push(data)
      this.canDownload = this.selectedDocsForDownload.length > 1 ? true : false;
      this.selectedTemplateCount++;
    } else {
      this.selectedDocsForDownload = this.selectedDocsForDownload.filter(sd => sd.id != data.id);
      this.canDownload = this.selectedDocsForDownload.length > 1 ? true : false;
      this.selectedTemplateCount--;
    }
  }

  isSelected(doc) {
    return this.selectedDocsForDownload.indexOf(doc) > -1 ? true : false
  }

  selectAllForDownload(event) {
    this.canDownload = event.target.checked;//event.target.checked;
    this.selectedDocsForDownload = this.canDownload ? this.currentDocuments : [];

  }

  clearSearchText() {
    this.searchText = '';
    this.clearSearch();
  }

  downloadSelectedTemplate() {
    this.selectedDocsForDownload.map(data => {
      this.downloadTemplate(data.id, data.sharepointId, data.name);
    })
  }

  switchDeckView() {
    this.router.navigate(["Home/Templates"]);
  }

  backButtonClick() {
    this.router.navigate(['/Home']);
  }

  addTemplate() {
    //todo: write media queries for responsiveness
    const dialogRef = this.dialog.open(TemplateCreationComponent, {
      width: auto,
      height: auto,
      disableClose: true,
      panelClass: 'view-file',
      data: { categoryTypes: this.templates, title: "Add ", templateId: this.selectedTemplate },
    });
    if (window.innerWidth <= 600) {
      const dialogRef = this.dialog.open(TemplateCreationComponent, {
        width: '325px',
        maxWidth: '95vw',
        height: '60vh',
        disableClose: true,
        panelClass: 'view-file',
        data: { categoryTypes: this.templates, title: "Add ", templateId: this.selectedTemplate },
      });
    }
    dialogRef.afterClosed().subscribe(result => {
      //todo: temporary fix; need to refresh data only
      if (result) {
        this.cd.detectChanges();
        const filteredData = result.map(item => {
          item.CategoryId = parseInt(item.CategoryId, 10);
          item.SubCategoryId = parseInt(item.SubCategoryId, 10);
          item.templateId = parseInt(item.templateId, 10);
          item.SubCategoryTemplateId = parseInt(item.SubCategoryTemplateId, 10);
          return item;
        });

        this._service.AddTemplates(result).subscribe(res => {
          if (res) {
            this.templates.forEach(i => {

              let count = result.filter(item => item.templateId === i.id).length;
              if (count) {
                i.docCount += count;
              }
            });
            setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
            this.cd.detectChanges();
            this.toastr.success("Artifactories successfully added")

          }
        })
      }
    });
  }

  getTemplatesById(id, from: number, size) {
    this.cd.detectChanges();

    this.selectedTemplate = id

    this.canDownload = false;
    this.selectedTemplateName = this.templates.find(({ id }) => id === this.selectedTemplate).category;

    this.type = this.selectedTemplateName
    this.loading = true;
    this._service.getAllTemplatesById(id, from, size).subscribe(res => {
      this.loading = false;
      if (res.succeeded) {
        if (this.searchText.length > 0) {
          this.currentDocuments = Object.assign([], res.data.filter(doc => doc.subCategoryTemplate.toLowerCase().includes(this.searchText.toLowerCase())
            || doc.templateDescription.toLowerCase().includes(this.searchText.toLowerCase())
            || doc.templateTags.toLowerCase().includes(this.searchText.toLowerCase())
            || doc.subCategoryTemplate.toLowerCase().includes(this.searchText.toLowerCase())
            || doc.fileText.toLowerCase().includes(this.searchText.toLowerCase())
          ))
        } else {
          this.currentDocuments = Object.assign([], res.data.sort((a, b) => a.name.localeCompare(b.name)));
        }
        this.cd.detectChanges();
      }
    }, error => {
      this.currentDocuments = Object.assign([]);
      this.cd.detectChanges();
      this.loading = false;
    })
  }

  downloadTemplate(uuid, sharepointId, name) {
    this._service.downloadTemplate(uuid, sharepointId).subscribe(res => {
      var url = res.message
      this.downloadFile(url, name);
      if (this.showTemplates) {
        this.templates.map(i => {
          if (i.id == this.selectedTemplate) {
            i.downloadCount = i.downloadCount + 1;
          }
        })
        setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
      } else {
        setTimeout(() => this.searchButton(), 1000);
      }
    })
  }

  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  downloadFile(url, name) {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = String(name);
    a.click();
    a.remove();
  }

  clearSearch() {
    if (this.searchText == "") {
      this.searchButton();
    }
  }

  searchButton() {
    if (this.searchText != "") {
      this.loading = true
      this.searchResultsViewFlag = true;
      this.showTemplates = false;
      this.searchTemplateModel.searchTerm = this.searchText;
      this.searchTemplateModel.operator = false;
      this.searchTemplateModel.filterList = [this.type]

      this._service.SearchTemplates(this.searchTemplateModel).subscribe(res => {
        let result = res.data.templateResponse.items;
        this.templateResponse = result;
        this.templateResponseForTable = result.slice(0, 5);
        let template = this.templates;
        this.loading = false
        this.cd.detectChanges();
      })
    } else {
      this.searchResultsViewFlag = false;
      this.showTemplates = true;
      this.templateResponse = [];
      this.getTemplatesById(this.selectedTemplate, 0, this.artifactoryView === 'card' ? 8 : 5);
    }
  }

  openUpdateTemplate(data, type) {
    if (data) {
      data = {
        values: [data],
        type: type,
        name: data.fileName
      };
    } else {
      data = {
        values: this.currentDocuments,
        type: type,
        name: data.fileName
      }
    }
    const dialogRef = this.dialog.open(UpdateTemplateModal, {
      width: '450px',
      height: auto,
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedDocsForDownload = [];
        this.cd.detectChanges();
        this.templates.forEach(i => {
          if (result.presentCategoryId == i.id) {
            i.downloadCount = i.downloadCount - result.downloadCount;
            i.docCount = i.docCount - result.foldersCount;
          } else if (result.newCategoryId == i.id) {
            i.downloadCount = i.downloadCount + result.downloadCount;
            i.docCount = i.docCount + result.foldersCount;
          }
        })
        this.cd.detectChanges();
        if (this.searchText) {
          setTimeout(() => this.searchButton(), 1000);
        } else {
          setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
        }
      }
    });
  }

  viewFile(url, id) {
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { iFrameURL: url },
    });
    this.updateViewCount(id);
  }

  updateViewCount(id) {
    this._service.updateViewCount(id).subscribe(res => {

    }, error => {
    });
  }

  openEditTemplate(data) {
    if (!data.changesAllowed && (this.auth.getEmailId() != data.emailAddress)) {
      this.toastr.error("This Artifactory cannot be edited");
      return
    }
    data.title = "Edit "
    data.categoryTypes = this.templates
    data.serviceLinesForDropDown = this.serviceLinesForDropDown
    data.serviceLines = this.serviceLines
    const dialogRef = this.dialog.open(TemplateCreationComponent, {
      width: auto,
      height: auto,
      disableClose: true,
      panelClass: 'view-file',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cd.detectChanges();
        localStorage.setItem("selectedTemplate", this.selectedTemplate.toString())
        this._service.AddTemplates(result).subscribe(res => {
          this.toastr.success("Artifactory updated successfully")
          if (this.searchText) {
            setTimeout(() => this.searchButton(), 1000);
          }
          else {
            setTimeout(() => this.getTemplatesById(this.selectedTemplate,this.artifactoryView ? this.from : 0, this.artifactoryView === 'card' ? this.size : 5), 1000);
          }
        })
      }
    })
  }

  openDeleteTemplate(data, type) {
    data.categoryId = data.templateId
    if (data) {
      data = {
        values: [data],
        type: type,
        name: data.fileName
      };

    } else {
      data = {
        values: this.currentDocuments,
        type: type,
        name: data.fileName
      }

    }
    const dialogRef = this.dialog.open(DeleteTemplateModal, {
      width: auto,
      minWidth: '500px',
      height: auto,
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedDocsForDownload = [];
        this.cd.detectChanges();
        this.toastr.success("Successfully Deleted Artifactory")
        if (this.searchText) {
          setTimeout(() => this.searchButton(), 1000);
        } else {
          if (data.values[0].id) {
            this.templates[this.selectedTemplate - 1].docCount -= 1
            this.templates[this.selectedTemplate - 1].downloadCount -= data.values.reduce((total, doc) => total + doc.downloadCount, 0);

          } else {
            this.templates[this.selectedTemplate - 1].docCount -= data.values[0].length;
            this.templates[this.selectedTemplate - 1].downloadCount -= data.values[0].reduce((total, doc) => total + doc.downloadCount, 0);
          }

          this.cd.detectChanges();
          setTimeout(() => this.getTemplatesById(this.selectedTemplate, this.from, this.size), 1000);
        }
      }
    });
  }
  isAuthorizedUser(doc) {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Template.Admin') >= 0 || roles.indexOf('CompetencyLeader') >= 0 || roles.indexOf('SubCompetencyLeader') >= 0 || roles.indexOf('Leadership') >= 0 || roles.indexOf('Admin') >= 0)
      return true
    else {
      if (roles.indexOf('Template.User') >= 0) {
        if (doc.createdById.toString() == this.auth.getEmployeeId())
          return true;
      }
    }
    return false;
  }
  isAuthorizedforSelectAll() {
    var roles = this.auth.getRole();
    return roles.indexOf('Template.User') >= 0;
  }

  onScroll() {
    if (this.artifactoryView === 'table' || this.searchResultsViewFlag) {
      return;
    }
    let totalFiles = this.from
    this.from = this.currentDocuments.length
    if (this.from != totalFiles) {
      this._service.getAllTemplatesById(this.selectedTemplate, this.from, this.size).subscribe(res => {
        if (res.succeeded) {
          let scrolledDocs = Object.assign([], res.data.sort((a, b) => a.name.localeCompare(b.name)))
          let currentIds = this.currentDocuments.map(x => x.id)
          for (var data of scrolledDocs) {
            if (currentIds.indexOf(data.id) == -1) {
              this.fetchRating([data])
              this.currentDocuments = [...this.currentDocuments, data]
            }
          }
          this.cd.detectChanges();
        }
      }, error => {
        this.currentDocuments = Object.assign([]);
        this.cd.detectChanges();
      })
    }
  }

  navigateBack() {
    this._location.back();
  }

  toggleView(option) {
    if (this.artifactoryView === option) {
      return;
    }
    this.artifactoryView = option;
    if (this.searchResultsViewFlag) {
      this.templateResponseForTable = this.templateResponse.slice(0, 5);
    } else {
      this.getTemplatesById(this.selectedTemplate, 0, option === 'card' ? 8 : 5);
    }
  }

  getPaginatorData(event) {
    let from, size;
    if (event.previousPageIndex > event.pageIndex) {
      from = (event.pageIndex * 5);
      size = event.pageSize;
    }
    else {
      size = event.pageSize;
      from = (event.pageIndex * size);
    }
    if (this.searchResultsViewFlag) {
      this.templateResponseForTable = this.templateResponse.slice(from, from + size);
    } else {
      this.getTemplatesById(this.selectedTemplate, from, size);
    }
  }

  exportToExcel() {
    this._service.getAllTemplatesById(this.selectedTemplate, 0, this.selectedTemplateDocCount).subscribe((res) => {
      if (res && res.data && res.data.length) {
        const exportData = res.data.map((item) => {
          return {
            "Artifact Name": item.fileName,
            "Type": item.subCategoryTemplate,
            "Purpose": item.templateName,
            "Description": item.templateDescription,
            "Related Tags": item.templateTags.join(', '),
            "Contact Person": item.contactPerson,
          };
        });
        let fileName = `${this.selectedTemplateName}_Artifactory`;
        this.excel.exportAsExcelFile(exportData, fileName);
      } else {
        this.toastr.error('No data available to export');
      }
    });
  }
}
